import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmCheck = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon-llm-check",
    "data-icon": "icon-llm-check",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      d: "M20 6 9 17l-5-5"
    })
  }));
});
IconLlmCheck.displayName = 'IconLlmCheck';

export { IconLlmCheck };
//# sourceMappingURL=llm-check.js.map
